enum QBPaymentsCardTypeEnum {
    VISA = "VISA",
    MC = "MC",
    AMEX = "AMEX",
    DISC = "DISC",
    DINERS = "DINERS",
    JCB = "JCB",
}

export default QBPaymentsCardTypeEnum;
